export class CampoId {
  id:number;
  constructor(id:number) {
    this.id = id;
  }
}
